import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { useNavigate, useLocation } from "react-router-dom";
import AthleteOnBoardingScreen from "./AthleteOnBoardingScreen";

import React, { useEffect, useState } from "react";
import { call } from "services/axiosService/core";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useMaterialUIController } from "context";
import Loader from "pages/loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Snackbar from "@mui/material/Snackbar";
import Refresh from "pages/refresh/Refresh";
import MuiAlert from "@mui/material/Alert";
import * as Sentry from "@sentry/browser";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ViewInsightsButton = ({ id, user_id }) => {
  const navigate = useNavigate();
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>View Insight</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 3 }}
      >
        <Icon
          fontSize="large"
          color="inherit"
          onClick={() => navigate(`/insight/${id}/${user_id}`)}
        >
          psychology
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const TakeAssessmentButton = ({ id }) => {
  const navigate = useNavigate();
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>Take Assessment</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 3 }}
      >
        <Icon fontSize="large" color="inherit" onClick={() => navigate(`/assessment/${id}`)}>
          description
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const ResumeAssessmentButton = ({ id }) => {
  const navigate = useNavigate();
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>Resume Assessment</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 3 }}
      >
        <Icon fontSize="large" color="inherit" onClick={() => navigate(`/assessment/${id}`)}>
          description
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

export function AthleteDashboard() {
  const location = useLocation();
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [assessments, setAssessments] = useState([]);
  const [hadAssessment, setHadAssessment] = useState(false);
  const [resumeAssessment, setResumeAssessment] = useState(null);
  const [controller] = useMaterialUIController();
  const [openLoader, setOpenLoader] = useState(location.state ? location.state : false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [sessionExpired, setSessionExpired] = useState(false);
  const { profile } = controller;

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const tableData = {
    columns: [
      { Header: "name", accessor: "name" },
      { Header: "assigned date", accessor: "assigned_date" },
      { Header: "status", accessor: "status" },
      {
        Header: "actions",
        accessor: "actions",
        width: "15%",
      },
    ],

    rows: assessments,
  };

  tableData.rows = tableData.rows.map((row) => {
    let status;
    let id = row.id;
    let user_id = row.user_id;
    let action;
    if (row.status == "ready") {
      status = `completed-${row.completion_date}`;
    } else {
      status = row.status;
    }
    switch (status) {
      case "not started":
        action = <TakeAssessmentButton id={id} />;
        break;
      case "not_started":
        action = <TakeAssessmentButton id={id} />;
        break;
      case "in_progress":
        action = <ResumeAssessmentButton id={id} />;
        break;
      case "scoring":
        action = "";
        break;
      case "submitted":
        action = "";
        break;
      default:
        action = <ViewInsightsButton id={id} user_id={user_id} />;
    }

    return {
      id: row.id,
      actions: action,
      name: row.details.name,
      assigned_date: row.assigned_date,
      status: status,
    };
  });

  useEffect(() => {
    if (profile.status == "active") {
      loadingAssessmentsHandler();
    }
  }, []);

  const loadingAssessmentsHandler = () => {
    call(`users/${profile.id}/assessments`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setAssessments(res.data.Assessments);
          res.data.Assessments.map((item, index) => {
            if (
              item.status == "not_started" ||
              item.status == "in_progress" ||
              item.status == "not started"
            ) {
              setHadAssessment(true);
              setResumeAssessment(item);
              localStorage.setItem("ActiveAssessment", JSON.stringify(item));
            }
          });
        } else if (res.status == 404) {
          setAssessments([]);
          setOpenSnackbar(true);
        } else if (res.status == 440) {
          setSessionExpired(true);
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Sentry.captureException(err);
      });
  };

  return (
    <DashboardLayout>
      <AthleteOnBoardingScreen
        role="athlete"
        setOpenLoader={setOpenLoader}
        setSessionExpired={setSessionExpired}
      />
      <DashboardNavbar title={`Assessment Dashboard`} />
      {openLoader && (
        <LoadingAssessmentDialog
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
          loadingAssessmentsHandler={loadingAssessmentsHandler}
        />
      )}

      {hadAssessment && (
        <MDBox mt={2.5}>
          <MDAlert color="info">
            <MDTypography variant="body2" color="white" fontWeight="medium">
              {`Welcome ${profile.details.name.split(" ")[0]} ! you have `}
              <MDTypography
                component="a"
                href={`/assessment/${resumeAssessment.id}`}
                variant="body2"
                fontWeight="medium"
                color="dark"
              >
                1 new assessment
              </MDTypography>{" "}
              assigned to you.
              <br />
              Please{" "}
              <MDTypography
                component="a"
                href={`/assessment/${resumeAssessment.id}`}
                variant="body2"
                fontWeight="medium"
                color="dark"
              >
                Click Here
              </MDTypography>{" "}
              or on the table row below to complete your assigned assessment.
            </MDTypography>
          </MDAlert>
        </MDBox>
      )}

      <MDBox mt={6}>
        <MDBox mt={3} mb={3}>
          <Card>
            <MDBox p={2} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                Assessments
              </MDTypography>
            </MDBox>
            <DataTable
              entriesPerPage={false}
              table={tableData}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
            />
          </Card>
        </MDBox>
      </MDBox>

      <Snackbar
        autoHideDuration={10000}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity="info" sx={{ width: "100%" }}>
          You currently have no assigned assessments. Try refreshing this page, or contact Support
          at <a href="mailto:support@maxu.co"> support@maxu.co </a> if the issue continues.
        </Alert>
      </Snackbar>
      {sessionExpired && <Refresh />}
    </DashboardLayout>
  );
}

const LoadingAssessmentDialog = ({ setOpenLoader, openLoader, loadingAssessmentsHandler }) => {
  useEffect(() => {
    setTimeout(() => {
      loadingAssessmentsHandler();
      setOpenLoader(false);
    }, 10000);
  }, []);

  return (
    <Dialog open={openLoader} fullScreen>
      <DialogContent>
        <Loader loaderText="Preparing your assessment" />
      </DialogContent>
    </Dialog>
  );
};
